export default {
    url: '/company',
    template: '<manage-permissions-users-detail-company form="vm.form" user="vm.user"/>',
    resolve: {
        userAssignments (UserAssignmentResource, $stateParams) {
            return UserAssignmentResource.query({ userId: $stateParams.id, onlyCompanyPrivileges: true }).$promise;
        }
    },
    controller (userAssignments, user) {
        this.user = user;
        this.form = {};
        this.form.model = {
            privileges: userAssignments.length === 0 ? [] : userAssignments[0].privilegesJson
        };
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/manage/permissions/users/detail/company/index.js